module.exports = {
  branchLocator: {
    name: 'branchLocator',
    class: 'branchLocator',
  },
  foundationCalculator: {
    name: 'foundationCalculator',
    class: 'dpws-tools-foundation-calculator',
  },
  overdraftCalculator: {
    name: 'overdraftCalculator',
    class: 'dpws-tools-overdraft-calculator',
  },
  overdraftUkCalculator: {
    name: 'overdraftUkCalculator',
    class: 'dpws-tools-overdraft-u-k-calculator',
  },
  travelMoneyCalculator: {
    name: 'travelMoneyCalculator',
    class: 'dpws-tools-travel-money-calculator',
  },
  hmcibCalculator: {
    name: 'hmcibCalculator',
    class: 'dpws-tools--h-m-c-i-b-calculator',
  },
  lmrCalculator: {
    name: 'lmrCalculator',
    class: 'dpws-tools--l-m-r-calculator',
  },
  savingToGoalCalculator: {
    name: 'savingToGoalCalculator',
    class: 'dpws-tools-saving-to-a-goal-calculator',
  },
  sfxCalculator: {
    name: 'sfxCalculator',
    class: 'dpws-tools--s-f-x-calculator',
  },
  calculatorCreator: {
    name: 'calculatorCreator',
    class: 'dpws-tools-calculator-creator',
  },
};
